import React from "react";

export const docMenu = [
  {
    name: "Introduction",
    dropDownItems: [
      {
        name: "Introduction",
        routerPath: "/quick/introduction",
      },
      {
        name: "Server requirements",
        routerPath: "/quick/recommendations",
      },
    ],
  },
  {
    name: "Backend Api",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/quick/server",
      },
      {
        name: "Installation",
        routerPath: "/quick/mandatory-setup-backend",
      },
      {
        name: "Payment installation",
        routerPath: "/quick/payment-installation",
      },
      {
        name: "Image settings",
        routerPath: "/quick/image-settings",
      },
      {
        name: "Troubleshooting",
        routerPath: "/quick/troubleshooting-backend",
      },
    ],
  },
  {
    name: "Admin Panel",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/quick/admin",
      },
      {
        name: "Installation",
        routerPath: "/quick/install-on-server",
      },
      {
        name: "Troubleshooting",
        routerPath: "/quick/troubleshooting-admin",
      },
    ],
  },
  // {
  //   name: "Customer Website",
  //   dropDownItems: [
  //     {
  //       name: "Requirements",
  //       routerPath: "/quick/front",
  //     },
  //     {
  //       name: "Installation",
  //       routerPath: "/quick/mandatory-setup-web",
  //     },
  //     // {
  //     //   name: "Troubleshooting",
  //     //   routerPath: "/",
  //     // },
  //   ],
  // },
  {
    name: "Customer App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/quick/mobile-app",
      },
      {
        name: "Installation",
        routerPath: "/quick/mandatory-setup-customer",
      },
      {
        name: "Customization",
        routerPath: "/quick/customization-customer",
      },
      {
        name: "App build & release",
        routerPath: "/quick/customer-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  // {
  //   name: "Seller and Driver App",
  //   dropDownItems: [
  //     {
  //       name: "Requirements",
  //       routerPath: "/quick/vendor-app",
  //     },
  //     {
  //       name: "Installation",
  //       routerPath: "/quick/mandatory-setup-vendor",
  //     },
  //     {
  //       name: "Customization",
  //       routerPath: "/quick/customization-vendor",
  //     },
  //     {
  //       name: "App build & release",
  //       routerPath: "/quick/vendor-app-build-release",
  //     },
  //     // {
  //     //   name: "Troubleshooting",
  //     //   routerPath: "/",
  //     // },
  //   ],
  // },
  // {
  //   name: "Driver App",
  //   dropDownItems: [
  //     {
  //       name: "Requirements",
  //       routerPath: "/quick/driver-app",
  //     },
  //     {
  //       name: "Installation",
  //       routerPath: "/quick/mandatory-setup-deliveryboy",
  //     },
  //     {
  //       name: "Customization",
  //       routerPath: "/quick/customization-deliveryboy",
  //     },
  //     {
  //       name: "App build & release",
  //       routerPath: "/quick/deliveryboy-app-build-release",
  //     },
  //     // {
  //     //   name: "Troubleshooting",
  //     //   routerPath: "/",
  //     // },
  //   ],
  // },
  // {
  //   name: "Pos App",
  //   dropDownItems: [
  //     {
  //       name: "Requirements",
  //       routerPath: "/quick/pos-app",
  //     },
  //     {
  //       name: "Installation",
  //       routerPath: "/quick/mandatory-setup-pos",
  //     },
  //     {
  //       name: "Customization",
  //       routerPath: "/quick/customization-pos",
  //     },
  //     {
  //       name: "App build & release",
  //       routerPath: "/quick/pos-app-build-release",
  //     },
  //     // {
  //     //   name: "Troubleshooting",
  //     //   routerPath: "/",
  //     // },
  //   ],
  // },
  {
    name: "Firebase setup",
    dropDownItems: [
      {
        name: "Website",
        routerPath: "/quick/firebase-web",
      },
      {
        name: "Mobile",
        routerPath: "/quick/firebase-mobile",
      },
    ],
    // routerPath: "/quick/firebase",
  },
  {
    name: "Update",
    routerPath: "/quick/update",
  },
];

export const payments = [
  {
    icon: (
      <img
        src={"./assets/img/root/paypal.png"}
        alt="img"
        width="80"
        height="80"
      />
    ),
  },
  {
    icon: (
      <img
        src={"./assets/img/root/stripe.png"}
        alt="img"
        width="80"
        height="80"
      />
    ),
  },
  {
    icon: (
      <img
        src={"./assets/img/root/razorpay.png"}
        alt="img"
        width="80"
        height="80"
      />
    ),
  },
  {
    icon: (
      <img
        src={"./assets/img/root/paystack.jpeg"}
        alt="img"
        width="120"
        height="120"
      />
    ),
  },
  {
    icon: (
      <img
        src={"./assets/img/root/pay-tabs.jpg"}
        alt="img"
        width="120"
        height="120"
      />
    ),
  },
  {
    icon: (
      <img
        src={"./assets/img/root/flw.png"}
        alt="img"
        width="110"
        height="120"
      />
    ),
  },
  {
    icon: (
      <img
        src={"./assets/img/root/mercado-pago.jpg"}
        alt="img"
        width="120"
        height="120"
      />
    ),
  },
  {
    icon: (
      <img
        src={"./assets/img/root/moyasar.png"}
        alt="img"
        width="120"
        height="120"
      />
    ),
  },
  {
    icon: (
      <img
        src={"./assets/img/root/mollie.png"}
        alt="img"
        width="120"
        height="120"
      />
    ),
  },
  {
    icon: (
      <img
        src={"./assets/img/root/maksekeskus.png"}
        alt="img"
        width="120"
        height="120"
      />
    ),
  },
];
